// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__qffHx","insightsList":"newBusinessInsightsMenu_insightsList__ETaax","active":"newBusinessInsightsMenu_active__DcE6r"};